import { LegacyRef, memo } from "react";

const VideoElement = (props: { videoRef: LegacyRef<HTMLVideoElement> | undefined; videoTitle: string | undefined; className?: string }) => {
  return (
    <video id="content_video" ref={props.videoRef} className={`video-js vjs-fluid ${props.className ?? ""}`} preload="none" controlsList="nodownload" title={props.videoTitle} onContextMenu={(e) => e.preventDefault()}>
      <p className="vjs-no-js">
        To view this video, please enable JavaScript and consider upgrading to a web browser that
        <a href="https://videojs.com/html5-video-support/" target="_blank" rel="noreferrer">supports HTML5 video</a>
      </p>
    </video>
  );
}

export default memo(VideoElement);